export default {
  items: [
    // {
    //   type: 'item',
    //   isHeader: true,
    //   name: 'sidebar.mainnavigation'
    // },
    {
      type: "item",
      icon: "fa fa-dashboard",
      name: "sidebar.dashboard",
      router: {
        name: "DashBoard"
      },
      meta: { code: "dashboard" }
    },
    {
      type: "item",
      icon: "fa fa-dashboard",
      name: "sidebar.search",
      router: {
        name: "Search"
      },
      meta: { code: "search" }
    },
    // {
    //   type: "tree",
    //   icon: "fa fa-envelope",
    //   name: "sidebar.emailmanagement.title",
    //   items: [
    //     // {
    //     //   type: "item",
    //     //   icon: "fa fa-circle-o",
    //     //   name: "sidebar.emailmanagement.mailbox",
    //     //   router: {
    //     //     name: "ManagementMailbox"
    //     //   }
    //     // },
    //     {
    //       type: "item",
    //       icon: "fa fa-circle-o",
    //       name: "sidebar.emailmanagement.compose",
    //       router: {
    //         name: "ManagementCompose"
    //       }
    //     },
    //   ]
    // },
    {
      type: "tree",
      icon: "fa fa-pie-chart",
      name: "sidebar.servicemanagement.title",
      items: [
        {
          type: "item",
          icon: "fa fa-circle-o",
          name: "sidebar.servicemanagement.service",
          router: {
            name: "ServiceList"
          },
          meta: { code: "service" }
        },
        // {
        //   type: "item",
        //   icon: "fa fa-circle-o",
        //   name: "sidebar.servicemanagement.package",
        //   router: {
        //     name: "PackageList"
        //   },
        //   meta: { code: "package" }
        // },
        // {
        //   type: "item",
        //   icon: "fa fa-circle-o",
        //   name: "sidebar.servicemanagement.coupons",
        //   router: {
        //     name: "Coupons"
        //   },
        //   meta: { code: "coupon" }
        // },
        {
          type: "item",
          icon: "fa fa-circle-o",
          name: "sidebar.servicemanagement.product",
          router: {
            name: "ProductList"
          },
          meta: { code: "product" }
        },
        {
          type: "item",
          icon: "fa fa-circle-o",
          name: "sidebar.servicemanagement.serviceOrder",
          router: {
            name: "ManagementServiceOrder"
          },
          meta: { code: "management_service_order" }
        }
      ],
      meta: { code: "service" }
    },
    {
      type: "tree",
      icon: "fa fa-group",
      name: "sidebar.usermanagement.title",
      items: [
        {
          type: "item",
          icon: "fa fa-circle-o",
          name: "sidebar.usermanagement.user",
          router: {
            name: "User"
          },
          meta: { code: "staff" }
        },
        {
          type: "item",
          icon: "fa fa-circle-o",
          name: "sidebar.customermanagement.customer",
          router: {
            name: "Customer"
          },
          meta: { code: "customer" }
        },
        // {
        //   type: "item",
        //   icon: "fa fa-circle-o",
        //   name: "sidebar.userguest.user_guest",
        //   router: {
        //     name: "UserGuest"
        //   }
        // }
        // {
        //   type: "item",
        //   icon: "fa fa-circle-o",
        //   name: "sidebar.companymanagement.company",
        //   router: {
        //     name: "CompanyList"
        //   },
        //   meta: { code: "customer" }
        // }
      ],
      meta: { code: "user" }
    },
    {
      type: "item",
      icon: "fa fa-money",
      name: "sidebar.propertymanagement.assetList",
      router: {
        name: "AssetList"
      },
      meta: { code: "asset" }
    },
    {
      type: "item",
      icon: "fa fa-wrench",
      name: "sidebar.propertymanagement.technicalManager",
      router: {
        name: "MaintenanceList"
      },
      meta: { code: "maintenance" }
    },
    // {
    //   type: "tree",
    //   icon: "fa fa-money",
    //   name: "sidebar.propertymanagement.title",
    //   items: [
    //     // {
    //     //   type: "item",
    //     //   icon: "fa fa-circle-o",
    //     //   name: "sidebar.propertymanagement.property",
    //     //   router: {
    //     //     name: "PropertyList"
    //     //   },
    //     //   meta: { code: "meter" }
    //     // },
    //     {
    //       type: "item",
    //       icon: "fa fa-circle-o",
    //       name: "sidebar.propertymanagement.asset",
    //       router: {
    //         name: "AssetList"
    //       },
    //       meta: { code: "asset" }
    //     },
    //     {
    //       type: "item",
    //       icon: "fa fa-circle-o",
    //       name: "sidebar.propertymanagement.maintenance",
    //       router: {
    //         name: "MaintenanceList"
    //       },
    //       meta: { code: "maintenance" }
    //     }
    //   ],
    //   meta: { code: "asset" }
    // },
    // {
    //   type: "tree",
    //   icon: "fa fa-list-alt",
    //   name: "sidebar.advertise.title",
    //   items: [
    //     {
    //       type: "item",
    //       icon: "fa fa-circle-o",
    //       name: "sidebar.advertise.advertiselist",
    //       router: {
    //         name: "AdvertiseList"
    //       },
    //       meta: { code: "advertise" }
    //     },
    //     {
    //       type: "item",
    //       icon: "fa fa-circle-o",
    //       name: "sidebar.advertise.advertiseprojectinfolist",
    //       router: {
    //         name: "AdvertiseProjectInfoList"
    //       }
    //     }
    //   ],
    //   meta: { code: "advertise" }
    // },
    {
      type: "tree",
      icon: "fa fa-list-alt",
      name: "sidebar.mobileHomeManagement.title",
      items: [
        {
          type: "item",
          icon: "fa fa-circle-o",
          name: "newsManagement.residentNewsTitle",
          router: {
            name: "ResidentsList"
          },
          meta: { code: "resident" }
        },
        {
          type: "item",
          icon: "fa fa-circle-o",
          name: "newsManagement.news",
          router: {
            name: "NewsList"
          },
          meta: { code: "news" }
        },
        // {
        //   type: "item",
        //   icon: "fa fa-circle-o",
        //   name: "newsManagement.newsCategories",
        //   router: {
        //     name: "NewsCategoriesList"
        //   },
        //   meta: { code: "categories" }
        // },
        {
          type: "item",
          icon: "fa fa-circle-o",
          name: "eventManagement.eventList",
          router: {
            name: "eventManagementList"
          },
          meta: { code: "event_management" }
        },
        {
          type: "item",
          icon: "fa fa-desktop",
          name: "sidebar.mobileHomeManagement.title",
          router: {
            name: "HomeMobileManagementAdd"
          },
          meta: { code: "home_mobile_management" }
        },
        {
          type: "item",
          icon: "fa fa-question-circle-o",
          name: "sidebar.frequentlyAskedQuestions.title",
          router: {
            name: "FrequentlyAskedQuestionsList"
          },
          meta: { code: "frequently_asked_questions" }
        }
      ],
      meta: { code: "news" }
    },
    // {
    //   type: "tree",
    //   icon: "fa fa-list-alt",
    //   name: "sidebar.realestatemanagement.title",
    //   items: [
    //     {
    //       type: "item",
    //       icon: "fa fa-circle-o",
    //       name: "sidebar.realestatemanagement.realestate",
    //       router: {
    //         name: "ApartmentRealestateList"
    //       },
    //       meta: { code: "bds" }
    //     },
    //     {
    //       type: "item",
    //       icon: "fa fa-circle-o",
    //       name: "sidebar.scheduleprogressmanagement.scheduleprogress",
    //       router: {
    //         name: "ApartmentScheduleProgressList"
    //       },
    //       meta: { code: "scheduleprogress" }
    //     },
    //     {
    //       type: "item",
    //       icon: "fa fa-circle-o",
    //       name: "sidebar.contract.apartmentcontractlist",
    //       router: {
    //         name: "ApartmentContractList"
    //       },
    //       meta: { code: "contract" }
    //     }
    //   ],
    //   meta: { code: "bds" }
    // },
    {
      type: "tree",
      icon: "fa fa-home",
      name: "sidebar.apartmentandownermanagement.title",
      items: [
        {
          type: "item",
          icon: "fa fa-circle-o",
          name: "sidebar.apartmentandownermanagement.apartment",
          router: {
            name: "ApartmentList"
          },
          meta: { code: "apartment" }
        },
        {
          type: "item",
          icon: "fa fa-circle-o",
          name: "sidebar.apartmentandownermanagement.apartmentGroup",
          router: {
            name: "ApartmentGroupList"
          },
          meta: { code: "apartmentGroup" }
        },
        {
          type: "item",
          icon: "fa fa-circle-o",
          name: "sidebar.apartmentandownermanagement.memberRegistrationList",
          router: {
            name: "ApprovalApartmentResidentList"
          },
          meta: { code: "approval_apartment_resident" }
        },
        {
          type: "item",
          icon: "fa fa-circle-o",
          name: "sidebar.apartmentandownermanagement.apartmentType",
          router: {
            name: "ApartmentTypeAndApartmentGroup"
          },
          meta: { code: "apartment_type" }
        },
        {
          type: "item",
          icon: "fa fa-circle-o",
          name: "sidebar.apartmentandownermanagement.register_export_invoice",
          router: {
            name: "UserRegisterExportInvoice"
          },
          meta: { code: "register_export_invoice" }
        },
        // {
        //   type: "item",
        //   icon: "fa fa-circle-o",
        //   name: "sidebar.apartmentandownermanagement.apartmentAndService",
        //   router: {
        //     name: "ProductAndServiceInApartment"
        //   },
        //   meta: { code: "product_and_service" }
        // },
        {
          type: "item",
          icon: "fa fa-circle-o",
          name: "sidebar.apartmentandownermanagement.apartmentDiagram",
          router: {
            name: "ApartmentDiagramList"
          },
          meta: { code: "apartment_diagram" }
        },
        {
          type: "item",
          icon: "fa fa-circle-o",
          name: "sidebar.apartmentandownermanagement.apartmentBooking",
          router: {
            name: "ApartmentBookingList"
          },
          meta: { code: "apartment_booking" }
        },
        {
          type: "item",
          icon: "fa fa-circle-o",
          name: "sidebar.apartmentandownermanagement.room_bill",
          router: {
            name: "RoomBill"
          },
          meta: { code: "room_bill" }
        },
        {
          type: "item",
          icon: "fa fa-circle-o",
          name: "sidebar.apartmentandownermanagement.apartmentTypePrice",
          router: {
            name: "ApartmentTypeListWithPrice"
          },
          meta: { code: "apartment_booking" }
        }
      ],
      meta: { code: "apartment" }
    },
    // {
    //   type: "tree",
    //   icon: "fa fa-user",
    //   name: "sidebar.leasebackmanagement.title",
    //   items: [
    //     {
    //       type: "item",
    //       icon: "fa fa-circle-o",
    //       name: "sidebar.leasebackmanagement.leaseback",
    //       router: {
    //         name: "LeaseBackApartmentList"
    //       },
    //       meta: { code: "leaseback" }
    //     },
    //     {
    //       type: "item",
    //       icon: "fa fa-circle-o",
    //       name: "sidebar.leasebackmanagement.availableleaseback",
    //       router: {
    //         name: "LeaseBackAvailableApartmentList"
    //       },
    //       meta: { code: "leaseback" }
    //     },
    //     {
    //       type: "item",
    //       icon: "fa fa-circle-o",
    //       name: "sidebar.leasebackmanagement.reservation",
    //       router: {
    //         name: "ApartmentReservationList"
    //       },
    //       meta: { code: "apartment_reservation" }
    //     },
    //     {
    //       type: "item",
    //       icon: "fa fa-circle-o",
    //       name: "sidebar.leasebackmanagement.invoice_booking_payment",
    //       router: {
    //         name: "InvoiceBookingPaymentList"
    //       }
    //       // meta: { code: "apartment_invoice_booking_payment" }
    //     },
    //     {
    //       type: "item",
    //       icon: "fa fa-circle-o",
    //       name: "sidebar.leasebackmanagement.invoice_general_invoice",
    //       router: {
    //         name: "InvoiceGeneralInvoiceList"
    //       }
    //       // meta: { code: "invoice_general_invoice" }
    //     },
    //     {
    //       type: "item",
    //       icon: "fa fa-circle-o",
    //       name: "sidebar.leasebackmanagement.customer_company",
    //       router: {
    //         name: "LeaseBackCustomerCompanyList"
    //       }
    //     },
    //     {
    //       type: "item",
    //       icon: "fa fa-circle-o",
    //       name: "sidebar.leasebackmanagement.resident_clients",
    //       router: {
    //         name: "LeaseBackResidentClientList"
    //       }
    //     },
    //     {
    //       type: "item",
    //       icon: "fa fa-circle-o",
    //       name: "sidebar.leasebackmanagement.statistics_of_breakfast",
    //       router: {
    //         name: "LeaseBackStatisticsOfBreakfastResidentClients"
    //       }
    //     },
    //     {
    //       type: "item",
    //       icon: "fa fa-circle-o",
    //       name: "sidebar.leasebackmanagement.room_policy",
    //       router: {
    //         name: "RoomPolicyList"
    //       }
    //     },
    //     {
    //       type: "item",
    //       icon: "fa fa-circle-o",
    //       name: "sidebar.leasebackmanagement.service_clean_room",
    //       router: {
    //         name: "LeaseBackApartmentCleaningServiceManagement"
    //       }
    //     }
    //   ],
    //   meta: { code: "leaseback" },
    //   disabled: false
    // },
    {
      type: "tree",
      icon: "fa fa-feed",
      name: "sidebar.customerfeedbackmanagement.title",
      items: [
        {
          type: "item",
          icon: "fa fa-circle-o",
          name: "sidebar.customerfeedbackmanagement.customerfeedback",
          router: {
            name: "CaseList"
          },
          meta: { code: "case" }
        },
        // {
        //   type: "item",
        //   icon: "fa fa-circle-o",
        //   name: "sidebar.customerfeedbackmanagement.escalationprocess",
        //   router: {
        //     name: "EscalationProcess"
        //   },
        //   meta: { code: "escalation_process" }
        // },
        // {
        //   type: "item",
        //   icon: "fa fa-circle-o",
        //   name: "sidebar.customerfeedbackmanagement.escalationstage",
        //   router: {
        //     name: "EscalationStage"
        //   },
        //   meta: { code: "escalation_stage" }
        // },
        {
          type: "item",
          icon: "fa fa-circle-o",
          name: "sidebar.customerfeedbackmanagement.send_message",
          router: {
            name: "ManagementMenu"
          },
          meta: { code: "send_notification" }
        },
        // {
        //   type: "item",
        //   icon: "fa fa-circle-o",
        //   name: "sidebar.customerfeedbackmanagement.emailform",
        //   router: {
        //     name: "ManagementEmailFormList"
        //   },
        //   meta: { code: "form_email_list" }
        // },
        // {
        //   type: "item",
        //   icon: "fa fa-circle-o",
        //   name: "sidebar.customerfeedbackmanagement.to_do_list",
        //   router: {
        //     name: "TodoList"
        //   },
        //   meta: { code: "to_do_list" }
        // }
      ],
      meta: { code: "case" }
    },
    //quan ly giao dien chua su dung
    // {
    //   type: "tree",
    //   icon: "fa fa-building",
    //   name: "sidebar.interfaceadvertisingManagement.title",
    //   items: [
    //     {
    //       type: "item",
    //       icon: "fa fa-circle-o",
    //       name: "sidebar.interfaceadvertisingManagement.interface",
    //       router: {
    //         name: "CommingSoon"
    //       },
    //       meta: { code: "gui" }
    //     }
    //   ],
    //   meta: { code: "gui" },
    //   disabled: true
    // },
    // {
    //   type: "tree",
    //   icon: "fa fa-money",
    //   name: "sidebar.decentralizationManagement.title",
    //   items: [
    //     {
    //       type: "item",
    //       icon: "fa fa-circle-o",
    //       name: "sidebar.decentralizationManagement.decentralizationGroup",
    //       router: {
    //         name: "DecentralizationGroup"
    //       },
    //       meta: { code: "decentralizationUser" }
    //     }
    //   ],
    //   meta: { code: "decentralization" }
    // },
    //quan ly thanh toan chua su dung
    // {
    //   type: "tree",
    //   icon: "fa fa-cc-visa",
    //   name: "sidebar.paymentgatewayManagement.title",
    //   items: [
    //     {
    //       type: "item",
    //       icon: "fa fa-circle-o",
    //       name: "sidebar.paymentgatewayManagement.paymentgateway",
    //       router: {
    //         name: "CommingSoon"
    //       },
    //       meta: { code: "payment" }
    //     }
    //   ],
    //   meta: { code: "payment" },
    //   disabled: true
    // },
    {
      type: "tree",
      icon: "fa fa-cube",
      name: "sidebar.invoiceManagement.title",
      items: [
        {
          type: "item",
          icon: "fa fa-circle-o",
          name: "sidebar.invoiceManagement.invoice",
          router: {
            name: "InvoiceList"
          },
          meta: { code: "invoice" }
        },
        {
          type: "item",
          icon: "fa fa-circle-o",
          name: "sidebar.invoiceManagement.receipt",
          router: {
            name: "ReceiptList"
          },
          meta: { code: "receipt_list" }
        }
      ],
      meta: { code: "invoice" }
    },
    {
      type: "tree",
      icon: "fa fa-table",
      name: "sidebar.StatisticreportManagement.title",
      items: [
        {
          type: "item",
          icon: "fa fa-circle-o",
          name: "sidebar.StatisticreportManagement.liabilitiesReport",
          router: {
            name: "LiabilitiesReport"
          },
          meta: { code: "liabilities" }
        },
        {
          type: "item",
          icon: "fa fa-circle-o",
          name: "sidebar.StatisticreportManagement.accountinghomeliability",
          router: {
            name: "AccountingHomeLiabilityList"
          },
          meta: { code: "accountinghomeliability" }
        },
        {
          type: "item",
          icon: "fa fa-circle-o",
          name:
            "sidebar.StatisticreportManagement.reportaccountinghomeliability",
          router: {
            name: "ReportAccountingHomeLiability"
          },
          meta: { code: "incurred_liabilitities_report" }
        },
        {
          type: "item",
          icon: "fa fa-circle-o",
          name:
            "sidebar.StatisticreportManagement.report_accounting_home_liability_detail",
          router: {
            name: "ReportAccountingHomeLiabilityDetail"
          },
          meta: { code: "accounting_home_liability_detail" }
        },
        {
          type: "item",
          icon: "fa fa-circle-o",
          name: "sidebar.StatisticreportManagement.revenueReport",
          router: {
            name: "ApartmentReceipt"
          },
          meta: { code: "apartment_receipt" }
        },
        {
          type: "item",
          icon: "fa fa-circle-o",
          name: "sidebar.StatisticreportManagement.roomPerformanceReport",
          router: {
            name: "RoomPerformanceReport"
          },
          meta: { code: "room_performance_report" }
        }
      ],
      meta: { code: "report" }
    },
    // quan ly mua sam chua su dung
    // {
    //   type: "tree",
    //   icon: "fa fa-cube",
    //   name: "sidebar.onlineshoppingManagement.title",
    //   items: [
    //     {
    //       type: "item",
    //       icon: "fa fa-circle-o",
    //       name: "sidebar.onlineshoppingManagement.onlineshopping",
    //       router: {
    //         name: "CommingSoon"
    //       },
    //       meta: { code: "shop" }
    //     }
    //   ],
    //   meta: { code: "shop" },
    //   disabled: true
    // },
    {
      type: "tree",
      icon: "fa fa-cog",
      name: "sidebar.projectsettings.title",
      items: [
        // {
        //   type: "item",
        //   icon: "fa fa-circle-o",
        //   name: "sidebar.projectsettings.batch_job",
        //   router: {
        //     name: "BatchJobList"
        //   }
        // },
        {
          type: "item",
          icon: "fa fa-circle-o",
          name: "sidebar.projectsettings.settings",
          router: {
            name: "ProjectInfoView"
          }
        },
        {
          type: "item",
          icon: "fa fa-circle-o",
          name: "sidebar.projecthistory.title",
          router: {
            name: "ProjectHistory"
          }
        },
        // {
        //   type: "item",
        //   icon: "fa fa-circle-o",
        //   name: "sidebar.projectsettings.usingemailtemplate",
        //   router: {
        //     name: "EmailTemplate"
        //   }
        // },
        // {
        //   type: "item",
        //   icon: "fa fa-circle-o",
        //   name: "sidebar.projectsettings.mobile.title",
        //   router: {
        //     name: "Mobile"
        //   },
        //   meta: { code: "mobile" }
        // },
        // {
        //   type: "item",
        //   icon: "fa fa-circle-o",
        //   name: "sidebar.projectsettings.rewardpoint.title",
        //   router: {
        //     name: "RewardPointManagement"
        //   },
        //   meta: { code: "rewardpoint" }
        // },
        // {
        //   type: "item",
        //   icon: "fa fa-circle-o",
        //   name: "sidebar.projectsettings.project_smtp",
        //   router: {
        //     name: "CustomizationProject_SMTP"
        //   },
        //   meta: { code: "customizationtable_smtp" }
        // },
        {
          type: "item",
          icon: "fa fa-circle-o",
          name: "sidebar.projectsettings.serversetting",
          router: {
            name: "CustomizationTable_SMTP"
          },
          meta: { code: "customizationtable_smtp" }
        },
        {
          type: "item",
          icon: "fa fa-bell",
          name: "sidebar.projectsettings.configTemplateNotification",
          router: {
            name: "NotificationCategory"
          },
          meta: { code: "config_template_notification" }
        },
        {
          type: "item",
          icon: "fa fa-circle-o",
          name: "sidebar.decentralizationManagement.decentralizationGroup",
          router: {
            name: "DecentralizationGroup"
          },
          meta: { code: "decentralizationUser" }
        }
      ],
      meta: { code: "project" }
    },
    // {
    //   type: "tree",
    //   icon: "fa fa-image",
    //   name: "banner.titleManagement",
    //   items: [
    //     {
    //       type: "item",
    //       icon: "fa fa-circle-o",
    //       name: "banner.list",
    //       router: {
    //         name: "BannerList"
    //       },
    //       meta: { code: "banner" }
    //     },
    //   ],
    //   meta: { code: "banner" }
    // },
    // {
    //   type: "item",
    //   icon: "fa fa-desktop",
    //   name: "sidebar.mobileHomeManagement.title",
    //   router: {
    //     name: "HomeMobileManagementAdd"
    //   },
    //   meta: { code: "home_mobile_management" }
    // },
    {
      type: "item",
      icon: "fa fa-question",
      name: "sidebar.documentation",
      router: {
        name: "Documentation"
      },
      meta: { code: "document" }
    }
  ]
};



// WEBPACK FOOTER //
// ./src/lib/slideMenuItems.js